<template>
    <div class="layout-cards grid grid-cols-1 gap-6 lg:grid-cols-3">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'LayoutCards',
};
</script>
